import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/api';
import { queryKeys } from '@/libs/queryKeys';
import { useAuth } from './useAuth';

/** React Query for the current user's in-progress echo drafts. Disabled when not signed in. */
export const useMyDraftsQuery = () => {
  const { isAuthenticated } = useAuth();

  return useQuery({
    queryKey: queryKeys.echoes.drafts,
    queryFn: api.echoes.listMyDrafts,
    enabled: isAuthenticated,
  });
};
